import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CurveArrowIconSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='89' height='107' viewBox='0 0 89 107' fill='none'>
    <path
      d='M88.0445 106.076C88.595 106.031 89.0051 105.549 88.9606 104.998C88.9161 104.448 88.4337 104.038 87.8833 104.082L88.0445 106.076ZM8.43984 0.826322C8.05672 0.42853 7.42367 0.416635 7.02587 0.799753L0.543479 7.04303C0.145687 7.42615 0.133792 8.05921 0.516911 8.457C0.90003 8.85479 1.53308 8.86668 1.93087 8.48357L7.693 2.93398L13.2426 8.69611C13.6257 9.0939 14.2588 9.1058 14.6566 8.72268C15.0543 8.33956 15.0662 7.70651 14.6831 7.30872L8.43984 0.826322ZM87.8833 104.082C74.3917 105.173 54.2016 101.386 37.5998 86.453C21.0268 71.5461 7.89507 45.4093 8.7194 1.53881L6.71975 1.50123C5.88731 45.8035 19.1586 72.5557 36.2623 87.9399C53.3372 103.298 74.0976 107.204 88.0445 106.076L87.8833 104.082Z'
      fill='#5E678C'
    />
  </svg>
);

export const CurveArrowIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CurveArrowIconSvg} {...props} />
);
